(() => {
  const ROOT = '[data-itcc-reviews-carousel]';

  const CHEVRON = (dir) => {
    const d =
      dir === 'left'
        ? 'M14.5 5.5 8 12l6.5 6.5'
        : 'M9.5 5.5 16 12l-6.5 6.5';
    return `<svg class="itcc-reviews-carousel__chevron" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="${d}" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  };

  const visibleCount = (width) => {
    if (width < 640) return 1;
    if (width < 980) return 2;
    return 3;
  };

  const decorateArrows = (root) => {
    const left = root.querySelector('.jdgm-carousel__left-arrow');
    const right = root.querySelector('.jdgm-carousel__right-arrow');

    if (left) {
      const mark = left.querySelector('.itcc-reviews-carousel__chevron');
      if (!mark || mark.getAttribute('data-dir') !== 'left') {
        left.innerHTML = CHEVRON('left');
        left.querySelector('.itcc-reviews-carousel__chevron')?.setAttribute('data-dir', 'left');
      }
      left.style.transform = 'none';
      left.setAttribute('aria-label', 'Previous reviews');
      left.setAttribute('role', 'button');
      left.tabIndex = 0;
    }

    if (right) {
      const mark = right.querySelector('.itcc-reviews-carousel__chevron');
      if (!mark || mark.getAttribute('data-dir') !== 'right') {
        right.innerHTML = CHEVRON('right');
        right.querySelector('.itcc-reviews-carousel__chevron')?.setAttribute('data-dir', 'right');
      }
      right.style.transform = 'none';
      right.setAttribute('aria-label', 'Next reviews');
      right.setAttribute('role', 'button');
      right.tabIndex = 0;
    }
  };

  const fullBodies = (root) => {
    if (root._itccFullBodies) return root._itccFullBodies;
    const map = new Map();
    const tpl = root.querySelector('template[data-itcc-reviews-full]');
    tpl?.content.querySelectorAll('.jdgm-carousel-item[data-review-id]').forEach((item) => {
      const body = item.querySelector('.jdgm-carousel-item__review-body');
      if (body) map.set(item.getAttribute('data-review-id'), body.innerHTML);
    });
    root._itccFullBodies = map;
    return map;
  };

  // Judge.me truncates bodies to its own line limit; put the full text back.
  const restoreBodies = (root) => {
    const map = fullBodies(root);
    if (!map.size) return;
    root.querySelectorAll('.jdgm-carousel-item[data-review-id]').forEach((item) => {
      const full = map.get(item.getAttribute('data-review-id'));
      const body = item.querySelector('.jdgm-carousel-item__review-body');
      if (full && body && body.innerHTML !== full) body.innerHTML = full;
    });
  };

  const layout = (root) => {
    restoreBodies(root);
    decorateArrows(root);

    const container = root.querySelector('.jdgm-carousel__item-container');
    const wrapper = root.querySelector('.jdgm-carousel__item-wrapper');
    const items = root.querySelectorAll('.jdgm-carousel-item, .jdgm-carousel__item');
    if (!container || !wrapper || !items.length) return;

    const gap = 16;
    const count = Math.min(visibleCount(container.clientWidth), items.length);
    const width = Math.max(220, Math.floor((container.clientWidth - gap * (count - 1)) / count));

    items.forEach((item) => {
      item.style.flex = `0 0 ${width}px`;
      item.style.width = `${width}px`;
      item.style.maxWidth = `${width}px`;
      item.style.boxSizing = 'border-box';
      item.style.marginLeft = '0';
      item.style.marginRight = `${gap}px`;
    });

    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'stretch';
    wrapper.style.gap = '0';
    wrapper.style.transition = 'transform 0.35s ease';

    if (!wrapper.dataset.itccLaidOut) {
      wrapper.style.transform = 'translateX(0)';
      wrapper.dataset.itccLaidOut = '1';
    }
  };

  const enhance = (root) => {
    if (!root || root.dataset.itccEnhanced === '1') return;
    root.dataset.itccEnhanced = '1';

    const run = () => layout(root);
    run();

    const resize = new ResizeObserver(run);
    resize.observe(root);

    const mo = new MutationObserver(() => run());
    mo.observe(root, { childList: true, subtree: true });

    root.querySelectorAll('.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow').forEach((btn) => {
      btn.addEventListener('click', () => window.requestAnimationFrame(run), { passive: true });
    });
  };

  const boot = () => {
    document.querySelectorAll(ROOT).forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.(ROOT) || event.target?.closest?.(ROOT);
    if (root) {
      root.dataset.itccEnhanced = '';
      enhance(root);
    }
  });

  window.addEventListener('load', () => {
    window.setTimeout(boot, 400);
    window.setTimeout(boot, 1200);
  });
})();
